import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { AdvancedFiltersContainer } from '../../containers/filters/AdvancedFiltersContainer';

export const advancedFilters: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: AdvancedFiltersContainer,
};
